import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Button } from 'antd'
import _ from 'lodash'
import '../../css/customer.scss'
import { Link } from 'react-router-dom'

const CompanyAction = (props) => {
  return (
    <>
      <Row className={'actionRow'}>
        <Col flex={'200px'}>
          <Row className={'headerText'}>Companies</Row>
        </Col>
        <Col>&nbsp;</Col>
        <Col style={{ alignSelf: 'center', marginLeft: 'auto' }}>
          <Row justify={'end'} align={'bottom'}>
            <Link to='/companies/add'>
              <Button className={'actionBtn'}>ADD</Button>
            </Link>
          </Row>
        </Col>
      </Row>
    </>
  )
}

CompanyAction.propTypes = {}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyAction)
